// src/components/seo/SEO.jsx
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

export default function SEO({
    title,
    description,
    image,
    canonical,
    type = 'website',
    publishedTime,
    modifiedTime,
    author,
    tags = [],
}) {
    const location = useLocation()
    const siteUrl = window.location.origin
    const currentUrl = canonical || `${siteUrl}${location.pathname}`

    const seo = {
        title: title ? `${title} | LogiQlink` : 'LogiQlink - Digital Transformation Experts',
        description: description || 'Leading IT branding company providing digital transformation, web development, and mobile app solutions',
        image: image || `${siteUrl}/og-image.jpg`,
        url: currentUrl,
        type,
    }

    return (
        <Helmet>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            {/* Open Graph */}
            <meta property="og:url" content={seo.url} />
            <meta property="og:type" content={seo.type} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />
            <meta property="og:site_name" content="LogiQlink" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />

            {/* Canonical */}
            <link rel="canonical" href={seo.url} />

            {/* Article specific meta */}
            {type === 'article' && (
                <>
                    {publishedTime && (
                        <meta property="article:published_time" content={publishedTime} />
                    )}
                    {modifiedTime && (
                        <meta property="article:modified_time" content={modifiedTime} />
                    )}
                    {author && (
                        <meta property="article:author" content={author} />
                    )}
                    {tags.map((tag, index) => (
                        <meta key={index} property="article:tag" content={tag} />
                    ))}
                </>
            )}
        </Helmet>
    )
}